import { DialogPosition } from '@angular/material/dialog';

import { DocumentModel } from './dido-document-model.type';
import { DocumenttypeModel } from './documenttype-model.type';

export class DidoGalleryDialogOptions {
    documenten?: DocumentModel[];
    readonly?: boolean;
    minWidth?: string | number;
    minHeight?: string | number;
    id?: string;
    position?: DialogPosition;
    panelClass?: string | string[];
    documenttypes?: DocumenttypeModel[];
    selectedDocument: DocumentModel;
    isUploadPreview?: boolean;
    showSideNavigation?: boolean = true;
    showOriButton?: boolean = true;
    showDeleteButton?: boolean = true;
}
